export default {
    namespaced: true,
    state: () => {
        return {
            current: 1,
            itemsCount: null,
            itemsPerPage: {value: 10, text: '10 per page'}
        }
    },
    getters: {
        config(state) {
            return {
                limit: state.itemsPerPage.value,
                offset: (state.current - 1) * state.itemsPerPage.value,
                totalCount: state.itemsCount
            }
        }
    },
    mutations: {
        setPerPage(state, perPage) {
            state.itemsPerPage = perPage;
        },
        setCurrentPage(state, page) {
            state.current = page;
        },
        setTotalCount: function(state, count) {
            state.itemsCount = count;
        }
    }
};
